import ContactInfoEdit from "../Edits/ContactInfoEdit";
import CmModal from "../Controls/CmModal";

export default function ContactInfoEditModal({ contactInfoId = 0, onClose }) {
  const id = Number.parseInt(contactInfoId, 10) || 0;
  const title = id > 0 ? "Contact Info" : "Add Contact Info";

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="form"
      testId="contact-info-edit-modal"
    >
      <ContactInfoEdit contactInfoId={id} onClose={onClose} />
    </CmModal>
  );
}
